import { isValidElement } from 'react'
import { dash } from '@/lib/format'
import { cn } from '@/lib/utils'

/** Label/value pairs that reflow into as many columns as the card's width allows. `mono` names the code rows. */
export function PackSection({ title, rows, mono = [] }: { title: string; rows: [string, unknown][]; mono?: string[] }) {
  return (
    <section className="space-y-3">
      <h2 className="text-[15px] font-bold">{title}</h2>
      <dl className="grid grid-cols-[repeat(auto-fill,minmax(18rem,1fr))] gap-x-6 gap-y-2.5 text-sm">
        {rows.map(([label, value]) => (
          <div key={label} className="grid grid-cols-[7rem_1fr] gap-3">
            <dt className="text-muted-foreground">{label}</dt>
            <dd className={cn('font-medium break-words', mono.includes(label) && 'font-mono')}>
              {/* The intake form stores "-" for a skipped field; show it like any other empty value. */}
              {isValidElement(value) ? value : dash(value === '-' ? null : value)}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  )
}
